enum Platforms {
  FULLSCRIPT = "Fullscript",
  WELLEVATE = "Wellevate",
}

export { Platforms };
